<template>
  <ListView
    modelName="Commodity"
    perm="master.menu_commodity"
    :items.sync="items"
    :params.sync="params"
    title="menu_commodity"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="Commodity"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    @selected="onSelectedMain"
    :comparer="(a,b)=>a.id == b.id"    
    tooltip="商品を登録します。販売側だけ、もしくは仕入側だけで使用する場合など、在庫を管理しない商品は、【棚卸商品区分】で【棚卸対象外】をチェックしてください。また【発注処理】を行う場合は、【仕入先】を指定してください。"
    :popup="popup"
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.code }}</GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.name }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.uom }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.isNoStock | isNoStock }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.model }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.manufacturer }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.name2 }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.name3 }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.netWeight }}</GridItem>
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.grossWeight }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }">{{ item.measurement }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.categoryCode1 | category_11 }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.categoryCode2 | category_12 }}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.categoryCode3 | category_13 }}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.categoryCode4 | category_14 }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.categoryCode5 | category_15 }}</GridItem>
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.categoryCode6 | category_16 }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.lastUpdatedBy | user }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView">
        <ListViewMenu slot="file_layout_download" icon="file_download" title="インポートファイル"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/%E5%95%86%E5%93%81%E3%83%9E%E3%82%B9%E3%82%BF%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="商品情報インポート用のレイアウトファイルをダウンロードします。" />
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <FilterBox title="コード" :value.sync="params.code" @click="handler" />
        <FilterBox title="名称" :value.sync="params.name" @click="handler" />
        <FilterBox title="メーカー" :value.sync="params.manufacturer" @click="handler" />        
        <FilterBox title="型番" :value.sync="params.model" @click="handler" />
        <FilterBox title="商品バーコード" :value.sync="params.barcode" @click="handler" />
        <ComboBox title="棚卸商品区分" :value.sync="params.isNoStock" list="isNoStock" @changed="handler" />
        <AtcCounterpart title="仕入先" :value.sync="params.supplier" :needsSupplier="true" @changed="handler" />        
        <AutoComplete title="category_11" :value.sync="params.categoryCode1" list="category_11" @changed="handler" />
        <AutoComplete title="category_12" :value.sync="params.categoryCode2" list="category_12" @changed="handler" />
        <AutoComplete title="category_13" :value.sync="params.categoryCode3" list="category_13" @changed="handler" />
        <AutoComplete title="category_14" :value.sync="params.categoryCode4" list="category_14" @changed="handler" />
        <AutoComplete title="category_15" :value.sync="params.categoryCode5" list="category_15" @changed="handler" />
        <AutoComplete title="category_16" :value.sync="params.categoryCode6" list="category_16" @changed="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> 
        <ComboBox title="状態" :value.sync="params.state" list="masterBaseStatus" @changed="handler" />          
      </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報', 'その他設定', '予備項目','SKU','荷姿','単価','棚番号', 'ワークフロー','更新履歴','添付ファイル']" :tabVisibles="tabVisibles"  :tabTooltips="[null,null,null,'【テナント設定】>【商品予備項目】の設定が反映されます。【受発注メモ】もしくは【入出荷メモ】が割当られている場合、活性化されます。ここで入力した内容は各伝票の予備項目に設定されます。','商品に登録されているSKUが表示されています。追加・修正は【SKU一覧】で行います。','商品に登録されている荷姿が表示されています。追加・修正は【荷姿一覧】で行います。','商品に登録されている単価が表示されています。追加・修正は【単価一覧】で行います。','商品に登録されている棚番号が表示されています。追加・修正は【棚番号一覧】で行います。',null,null,'商品の画像などの商品に関連するファイルをアップロードできます。状態が【確定】になっている場合は変更できないので、【確定取消】をする必要があります。']" >
        <!-- 遷移ボタン -->
        <template slot="menu" slot-scope="{ item, editor}">
          <SplitButton class="button" @click="showChildItems(item,'sku')" caption="SKU登録" :disabled="editor.isEdit || disableShowSku" icon="arrow_downward" tooltip="選択した商品データに紐づいているSKUマスタを表示します。" >
          <Button class="button" @click="showChildItems(item,'conversion')" caption="荷姿登録" :disabled="editor.isEdit || disableShowConversion" icon="arrow_downward" tooltip="選択した商品データに紐づいている荷姿マスタを表示します。" />
          <Button class="button" @click="showChildItems(item,'price')" caption="単価登録" :disabled="editor.isEdit || disableShowPrice" icon="arrow_downward" tooltip="選択した商品データに紐づいている単価マスタを表示します。" />
          <Button class="button" @click="showChildItems(item,'shelfNo')" caption="棚番号登録" :disabled="editor.isEdit || disableShowShelfNo" icon="arrow_downward" tooltip="選択した商品データに紐づいている棚番号マスタを表示します。" />
          </SplitButton>
        </template>        
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">              
              <TextBox title="コード" :value.sync="item.code" :editor="editor" :required="true" :enabled="listView.isInsertMode || tenantSettings.allowChangeCommodityCode" length="25" tooltip="商品データを管理するコードを入力します。同じコードの商品は登録できません。" />
              <TextBox title="名称" :value.sync="item.name" :editor="editor" :required="true" length="100" tooltip="商品の名前を入力します。ここで入力した値が､各明細一覧画面の商品欄に表示されます。" />
              <TextBox title="計上単位" :value.sync="item.uom" :editor="editor" :required="true" length="10" tooltip="商品に使う単位で､使用する最小となる単位を設定します。<br>計上単位と異なる単位で発注などを登録したい場合、荷姿を登録してください。<br><a href='https://support.s-flow.net/ja/articles/5271181' target='_blank'>詳細はサポートサイト</a>をご確認ください。" />
              <CheckBox title="棚卸商品区分" :value.sync="item.isNoStock" list="isNoStock" :editor="editor" v-if="$api.useStockFunction" tooltip="在庫管理を行わない場合チェックを入れます。<br>※棚卸対象から棚卸対象外への変更はきません。変更する場合は新しく商品を登録します。" 
              :alertValue="true" alertMessage="「棚卸対象外」は在庫管理が不要な商材(設置工事、保守サービスなど)に使用します。「棚卸対象外」として登録すると在庫処理(セット組立・セット分解を含む)が行えなくなりますのでご注意ください。"/>
              <RadioButton title="販売単価区分" :value.sync="item.priceType" :editor="editor" list="salesPricingTypes" :required="true" tooltip="商品を各明細に登録する際の､初期値としての単価取得方法を【販売単価掛率】と【単価マスタ】から指定できます。" />
              <NumericBox title="上代単価" :value.sync="item.sellingPrice" :editor="editor" :required="false" :decimals="item.stockPriceScale" min="0" max="999999999.999999" tooltip="【販売単価区分】で【販売単価掛率】が選択されている場合に、単価の計算に使われます。" />
              <RadioButton title="仕入単価区分" :value.sync="item.priceTypePurchase" :editor="editor" list="purchasePricingTypes" :required="true" tooltip="商品を各明細に登録する際の､初期値としての単価取得方法を【商品マスタ】と【単価マスタ】から指定できます。" />
              <NumericBox title="仕入単価" :value.sync="item.purchasePrice" :editor="editor" :decimals="item.stockPriceScale" min="0" max="999999999.999999" tooltip="受注での粗利計算の仕入単価として使われます。また、【仕入単価区分】で【商品マスタ】が選択されている場合に、単価の初期値として使われます。" />
              <Button class="button cx_itembutton" @click="showPriceCheckDialog(item)" caption="単価取得を確認" tooltip="単価取得条件を入力して算出される単価を確認できます。"/>
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">        
              <AtcCounterpart title="仕入先" :value.sync="item.supplier" :editor="editor" :needsSupplier="true" :required="item.replenishmentQuantity>0" tooltip="各明細一覧で商品を選択したときに、仕入先の項目に初期値として表示される【仕入先】を入力できます。仕入先が1つに決まっている場合に登録が推奨されます。" /> 
              <AtcTaxCode title="販売税区分" :value.sync="item.salesTaxCode" :editor="editor"  list="taxCode" tooltip="テナント設定で【商品ごとに税区分を設定する】が設定されている場合、受注明細や出荷明細を登録する際税区分の初期値に設定されます。" />
              <AtcTaxCode title="仕入税区分" :value.sync="item.purchaseTaxCode" :editor="editor" list="taxCode" tooltip="テナント設定で【商品ごとに税区分を設定する】が設定されている場合、発注明細や入荷明細を登録する際税区分の初期値に設定されます。" />
              <NumericBox title="数量小数桁数" :value.sync="item.quantityScale" :editor="editor"  min="0" max="3" decimals="0" tooltip="商品の数量の小数桁を何桁まで管理するかを入力できます。３桁まで指定可能です。<br>※1度確定すると変更できません。" />
              <RadioButton title="数量丸め方法" :value.sync="item.quantityRound" :editor="editor" list="roundTypes" :required="true" :enabled="isEditable(item)" tooltip="【数量小数桁数】で指定した桁数より小さな桁を､どのような基準で処理するかを入力できます。<br>※1度確定すると変更できません。" />
              <NumericBox title="在庫単価小数桁数" :value.sync="item.stockPriceScale" :editor="editor"  min="0" max="6" decimals="0" tooltip="在庫の単価の小数桁を何桁まで管理するかを入力できます。6桁まで指定可能です。<br>※1度確定すると変更できません。" />
              <RadioButton title="在庫単価丸め方法" :value.sync="item.stockPriceRound" :editor="editor" list="roundTypes" :required="true" :enabled="isEditable(item)" tooltip="【在庫単価小数桁数】で指定した桁数より小さな桁をどのような基準で処理するかを指定します。<br>※1度確定すると変更できません。" />
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="workflowRequired(item)" :enabled="workflowRequired(item)" :nullValue="0" />
              <TextBox title="所有者" :value="item.holder | user" :editor="editor" :enabled="false" />
              <TextBox title="状態" :value="item.state | masterBaseStatus" :editor="editor" :enabled="false" />            -->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="選択した商品データを最後に更新した日時が表示されます。" />
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="$api.perms.hasWorkflow('masterBase')" :enabled="$api.perms.hasWorkflow('masterBase') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="マスタ設定時に利用できるワークフローを指定します。【フロー区分】が【マスタ管理】になっているデータから選択ができます。" />
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="商品データの現在の状態が表示されており､ワークフロー欄の確定や使用停止ボタンをクリックすることで変化します。" />
            </template>
          </EditPanel>
        </template>
        <!-- その他設定タブ -->
        <template slot="tab1" slot-scope="{ editor, item }">
          <EditPanel >
            <!-- その他設定タブ 左側 -->
            <template slot="left">
              <NumericBox title="補充基準数量" :value.sync="item.minimumStockQuantity" :editor="editor" v-if="$api.useStockFunction" :enabled="item.isNoStock==false" :required="item.replenishmentQuantity>0" :isDirectEditEnabled="false" :decimals="item.quantityScale" min="0" max="99999999.999" tooltip="商品を補充する基準となる数値を入力できます。【予定在庫一覧】や管理帳票の【補充商品一覧表】で補充が必要かの判定に使用されます。" />
              <NumericBox title="補充数量" :value.sync="item.replenishmentQuantity" :editor="editor" v-if="$api.useStockFunction" :enabled="item.isNoStock==false" :isDirectEditEnabled="false" :required="item.replenishmentQuantity>0" :decimals="item.quantityScale" min="0" max="99999999.999" tooltip="補充が必要な商品を発注する際の数値を入力できます。予定在庫一覧から発注する際の発注数量の初期値として利用されます。" />
              <AtcConversion title="補充単位" :value.sync="item.replenishmentUom2" :editor="editor" v-if="$api.useStockFunction" :enabled="item.isNoStock==false" :isDirectEditEnabled="false" :commodity="item" :required="item.replenishmentQuantity>0" tooltip="補充数量の単位を設定できます。商品の計上単位もしくは荷姿を設定できます。予定在庫一覧から発注する際の単位の初期値として利用されます。"/>
              <NumericBox v-if="$api.customFunctionOpen($api.customFunctionFlags.expirationAlert)" title="アラート日数" :value.sync="item.expirationAlertDays" :editor="editor" :decimals="0" min="0" max="9999" suffix="日" tooltip="期限アラート通知を開始する日数を、0～9999の整数で入力します。0の場合、期限アラート通知を無効にします。" />
              <NumericBox v-if="$api.customFunctionOpen($api.customFunctionFlags.expirationAlert)" title="引当不可日数" :value.sync="item.allocationUnavailableDays" :editor="editor" :decimals="0" min="0" max="9999" suffix="日" tooltip="自動引当を制限する日数を、0～9999の整数で入力します。0の場合、引当制限を無効にします。" />

              <AutoComplete title="category_11" :value.sync="item.categoryCode1" path="/master/Category"   list="category_11" :editor="editor" :tooltip="'商品を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_11')+'】のデータを選択できます。'" />
              <AutoComplete title="category_12" :value.sync="item.categoryCode2" path="/master/Category"   list="category_12" :editor="editor" :tooltip="'商品を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_12')+'】のデータを選択できます。'" />
              <AutoComplete title="category_13" :value.sync="item.categoryCode3" path="/master/Category"   list="category_13" :editor="editor" :tooltip="'商品を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_13')+'】のデータを選択できます。'" />
              <AutoComplete title="category_14" :value.sync="item.categoryCode4" path="/master/Category"   list="category_14" :editor="editor" :tooltip="'商品を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_14')+'】のデータを選択できます。'" />
              <AutoComplete title="category_15" :value.sync="item.categoryCode5" path="/master/Category"   list="category_15" :editor="editor" :tooltip="'商品を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_15')+'】のデータを選択できます。'" />
              <AutoComplete title="category_16" :value.sync="item.categoryCode6" path="/master/Category"   list="category_16" :editor="editor" :tooltip="'商品を任意の区分で分類することができ、帳票の集計や検索等で利用できます。【区分一覧マスタ】＞【区分種別】が【'+$api.getWord('category_16')+'】のデータを選択できます。'" />
            </template>
            <!-- その他設定タブ 右側 -->
            <template slot="right">           
              <TextBox title="メーカー" :value.sync="item.manufacturer" :editor="editor" length="100" tooltip="商品のメーカーの情報を入力でき、値は帳票に利用できます。" />
              <TextBox title="型番" :value.sync="item.model" :editor="editor" length="100" tooltip="商品の型番の情報を入力でき、値は帳票に利用できます。" />
              <ComboBox title="バーコード種類" :value.sync="item.barcodeType" :editor="editor" list="barcodeTypes" :nullValue="0" :isDirectEditEnabled="false" tooltip="登録する商品に対応するバーコードの種類が選択できます。" />
              <TextBox title="商品バーコード" :value.sync="item.barcode" :editor="editor" :required="isRequiredBarcode(item.barcodeType)" length="25" :isDirectEditEnabled="false" tooltip="登録する商品のバーコード番号を登録する事ができます。" />              
              <CheckBox title="納入区分" :value.sync="item.deliveryFlag" list="deliveryFlagsCheck" :isDirectEditEnabled="false" :editor="editor" @changed="item.noPurchaseFlg = false" tooltip="受注を元にした一括発注処理で作成される発注の納入区分です。<br>※送料など、直送で得意先に請求するが、発注しない場合、<a href='https://support.s-flow.net/ja/articles/8185009' target='_blank'>こちらの方法</a>で発注書に載せないことが可能です。" />
              <CheckBox title="発注区分" :value.sync="item.noPurchaseFlg" list="noPurchaseFlg" :isDirectEditEnabled="false" :editor="editor" :enabled="!item.deliveryFlag" tooltip="発注を行うかどうかの区分です。発注対象外の場合受注を元にした発注処理で発注されません。<br>※納入区分で「直送」を指定した場合、発注対象外にできません。" />
              <CheckBox title="連携区分" :value.sync="item.noIntegrationFlg" list="integrationFlags" :isDirectEditEnabled="false" :editor="editor" tooltip="入荷や在庫移動で在庫が増減した際、EC連携先の在庫数を増やさないようにします。※売上の実績データは連携されます。" />
              <TextBox title="名称２" :value.sync="item.name2" :editor="editor"  length="100" v-if="hasLicenseTrade" />
              <TextBox title="名称３" :value.sync="item.name3" :editor="editor"  length="100" v-if="hasLicenseTrade" />
              <TextBox title="原産国" :value.sync="item.countryOfOrigin" :editor="editor" length="30" v-if="hasLicenseTrade" />
              <NumericBox title="Net(kg)" :value.sync="item.netWeight" :editor="editor" decimals="3" min="0" max="9999999.999" v-if="hasLicenseTrade" />
              <NumericBox title="Gross(kg)" :value.sync="item.grossWeight" :editor="editor" decimals="3" min="0" max="9999999.999" v-if="hasLicenseTrade" />
              <NumericBox title="Volume(m3)" :value.sync="item.measurement" :editor="editor" decimals="4" min="0" max="999999.9999" v-if="hasLicenseTrade" />
              <TextBox title="備考" :value.sync="item.description" :editor="editor" length="200" rows="3" tooltip="最大200文字まで任意の値を入力でき、値は帳票出力やメモなどに利用できます。この項目は各明細伝票の【備考】の初期値になります。" />
            </template>
          </EditPanel>
        </template>
        <!-- 連携設定タブ -->
        <!-- <template slot="tab2" slot-scope="{ editor, item }"> -->
          <!-- <EditPanel > -->
            <!-- <template slot="left"> -->
              <!-- <CheckBox title="EC連携先" :value.sync="item.ecFlag2" list="ecFlags" :isDirectEditEnabled="false" :editor="editor"  tooltip="EC連携先をチェックします。"    />     -->
              <!-- <TextBox title="ベイス商品ID" :value.sync="item.ecBaseId" :length="30" :required="(item.ecFlag & ecFlags.Base)>0" :enabled="(item.ecFlag & ecFlags.Base)>0" :editor="editor"   tooltip="ベイスの商品IDを指定します。" />                      -->
            <!-- </template> -->
            <!-- <template slot="right"> -->
            <!-- </template> -->
          <!-- </EditPanel> -->
        <!-- </template> -->
        <!-- 予備項目タブ -->
        <template slot="tab2" slot-scope="{ editor, item }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="true" :commodityAttribute="visibleTypes.None" :stockAttribute="visibleTypes.None"  :orderMemo="visibleTypes.Editable" :deliveryMemo="visibleTypes.Editable" :commodityMemo="visibleTypes.Editable" :commodity="item" /> 
        </template>
        <!-- 区分タブ -->
        <!-- <template slot="tab3" slot-scope="{ editor, item }">
          <EditPanel>
            <template slot="left"></template>
            <template slot="right"></template>
          </EditPanel>
        </template> -->
        <!-- 商品画像タブ -->
        <!-- <template slot="tab4" slot-scope="{ editor, item }">
          <EditPanel class="cx_commodity_tab">
            <template slot="left">
              <ListFiles title="商品画像" :editor="editor" parentKey="commodity" :parentId="item.id" height="300" />
            </template>
            <template slot="right">
              <TextBox title="画像備考" :value.sync="item.imageDescription" :editor="editor" length="200" rows="10" />
            </template>
          </EditPanel>
        </template> -->

        <!-- SKUタブ -->
        <template slot="tab3" slot-scope="{editor, item}">
          <GrdVoucherItem :voucherNo="item.code" :voucherItemType="voucherTypes.CommoditySKU" :showCheckBox="true"  :comparer="(a,b)=>a.auditNo == b.auditNo">
            <template slot="menu" slot-scope="{parent}">
              <Button class="button" @click="parent.onAdd"  perm="master.menu_sku.edit"  caption="SKUの追加" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="add"/>
              <Button class="button" @click="parent.onDelete" perm="master.menu_sku.edit"   caption="SKUの削除" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="delete"/>
            </template>                         
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="SKUマスタ" mode="editor" :isInsertMode="parent.insertMode" @closing="args=>parent.replaceItem(args.target)">
                <SKU slot-scope={popup} :popup="popup" :auditNo="parent.editItem ? parent.editItem.auditNo: null" :commodity="item"  ref="editor"/>
              </PopupEditor>
          </GrdVoucherItem>
        </template>     
        <!-- 荷姿タブ -->
        <template slot="tab4" slot-scope="{editor,  item}">
          <!-- <GrdVoucherItem :voucherNo="item.code" :voucherItemType="voucherTypes.CommodityConversion"/> -->
          <GrdVoucherItem :voucherNo="item.code" :voucherItemType="voucherTypes.CommodityConversion" :showCheckBox="true"  :comparer="(a,b)=>a.auditNo == b.auditNo">
            <template slot="menu" slot-scope="{parent}">
              <Button class="button" @click="parent.onAdd"  perm="master.menu_package.edit"  caption="荷姿の追加" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="add"/>
              <Button class="button" @click="parent.onDelete" perm="master.menu_package.edit"   caption="荷姿の削除" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="delete"/>
            </template>                         
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="荷姿マスタ" mode="editor" :isInsertMode="parent.insertMode" @closing="args=>parent.replaceItem(args.target)">
                <Conversion slot-scope={popup} :popup="popup" :auditNo="parent.editItem ? parent.editItem.auditNo: null" :commodity="item"  ref="editor"/>
              </PopupEditor>
          </GrdVoucherItem>
        </template>        
        <!-- 単価タブ -->
        <template slot="tab5" slot-scope="{editor,  item}">
          <!-- <GrdVoucherItem :voucherNo="item.code" :voucherItemType="voucherTypes.CommodityPrice"/> -->
          <GrdVoucherItem :voucherNo="item.code" :voucherItemType="voucherTypes.CommodityPrice" :showCheckBox="true"  :comparer="(a,b)=>a.auditNo == b.auditNo">
            <template slot="menu" slot-scope="{parent}">
              <Button class="button" @click="parent.onAdd"  perm="master.menu_package.edit"  caption="単価の追加" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="add"/>
              <Button class="button" @click="parent.onDelete" perm="master.menu_package.edit"   caption="単価の削除" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="delete"/>
            </template>                         
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="単価マスタ" mode="editor" :isInsertMode="parent.insertMode" @closing="args=>parent.replaceItem(args.target)">
                <Price slot-scope={popup} :popup="popup" :auditNo="parent.editItem ? parent.editItem.auditNo: null" :commodity="item"  ref="editor"/>
              </PopupEditor>
          </GrdVoucherItem>          
        </template>     
         <!-- 棚番号タブ -->
        <template slot="tab6" slot-scope="{editor,  item}">
          <!-- <GrdVoucherItem :voucherNo="item.code" :voucherItemType="voucherTypes.CommodityShelfNo"/> -->
          <GrdVoucherItem :voucherNo="item.code" :voucherItemType="voucherTypes.CommodityShelfNo" :showCheckBox="true"  :comparer="(a,b)=>a.auditNo == b.auditNo">
            <template slot="menu" slot-scope="{parent}">
              <Button class="button" @click="parent.onAdd"  perm="master.menu_package.edit"  caption="棚番号の追加" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="add"/>
              <Button class="button" @click="parent.onDelete" perm="master.menu_package.edit"   caption="棚番号の削除" :disabled="editor.isEdit || disabled(item) || parent.isLoading" icon="delete"/>
            </template>                         
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="棚番号マスタ" mode="editor" :isInsertMode="parent.insertMode" @closing="args=>parent.replaceItem(args.target)">
                <ShelfNo slot-scope={popup} :popup="popup" :auditNo="parent.editItem ? parent.editItem.auditNo: null" :commodity="item"  ref="editor"/>
              </PopupEditor>
          </GrdVoucherItem>          
        </template>    
        <!-- ワークフロータブ -->
        <template slot="tab7" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab8" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" :item="item"/>
        </template>
        <template slot="tab9" slot-scope="{ item, editor }">
          <ListFiles :editor="editor" title="添付ファイル" :height="300" :parentKey="item.auditName" :parentId="item.auditNo" />
        </template>
      </Editor>
      <b-modal class="dialog" v-model="priceCheckDialog" centered title='単価取得を確認' @ok="submitPriceCheck" :no-close-on-backdrop="true" v-if="priceCheckDialog"> 
      <!-- <ListDialog ref="priceCheckDialog" title="単価取得を確認" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitPriceCheck" > -->
        <!-- <template slot="header" slot-scope="{ editor }"> -->
          <ComboBox title="単価種別" :value.sync="priceCheckPriceType" :editor="priceCheckEditor" list="priceTypes" :required="true" :showDefault="false" tooltip="確認する単価種別を指定してください。" />
          <AtcCounterpart title="取引先" :value.sync="priceCheckCounterpart" :editor="priceCheckEditor" :required="true" :needsCustomer="priceCheckPriceType==1" :needsSupplier="priceCheckPriceType==2" tooltip="単価を確認したい取引先を指定してください。販売単価では得意先、仕入単価の場合は仕入先を指定します。" />
          <AtcSKU title="SKU" :value.sync="priceCheckSku" :editor="priceCheckEditor" :commodity="listView.selected" tooltip="単価を確認したいSKUを指定してください。" />
          <NumericBox title="数量" :value.sync="priceCheckQuantity" :editor="priceCheckEditor" :required="true" :decimals="listView.selected == null ? 0 : listView.selected.quantityScale" min="0" max="99999999.999" tooltip="単価を確認したい数量を指定してください。数量別の単価を使用していない場合、「1」のままで実行してください。" />
          <AtcConversion title="単位" :value.sync="priceCheckUom" :editor="priceCheckEditor" :required="true" :commodity="listView.selected" tooltip="単価を確認したい単位を指定してください。荷姿を使用していない場合、そのままで実行してください。" />
          <Calendar title="基準日" :value.sync="priceCheckBaseDate" :editor="priceCheckEditor" :deletable="false" :required="true" tooltip="基準日は、販売単価では受注日/出荷日、仕入単価では発注日/入荷日として判定します。" />
        <!-- </template> -->
        </b-modal>    
      <!-- </ListDialog> -->
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { Editor as ValidatorEditor } from '@/agiles/common/validator';

@Component
export default class CommodityView extends Vue {
  public items: Common.Commodity[] = new Array(0);
  public params: Common.CommodityQuery = new Common.CommodityQuery();
  public priceCheckDialog: boolean = false;
  public priceCheckPriceType: Common.PriceTypes = Common.PriceTypes.SalesPlice;
  public priceCheckCounterpart: Common.Counterpart = null;
  public priceCheckSku: Common.SKU = null;
  public priceCheckQuantity: number = 1;
  public priceCheckUom: Common.Conversion = null;
  public priceCheckBaseDate: Date = new Date().getCalendarDate();
  public priceCheckEditor: ValidatorEditor = new ValidatorEditor();
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true, true, true];
  public importQuery = new Common.CommodityImportQuery('商品');
  public exportQuery = new Common.CommodityExportQuery('商品',this.params);
  public tenantSettings: Common.TenantSettings = new Common.TenantSettings();
  public hasLicenseTrade: boolean = false;
  public visibleTypes = Common.visibleTypes;  
  public voucherTypes = Common.voucherTypes; //voucherTypesのエイリアス
  public ecFlags = Common.ECFlags;
  @Prop() public auditNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
   
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'manufacturer', text: 'メーカー' },
    { value: 'model', text: '型番' },
    { value: 'name2', text: '名称2' },
    { value: 'name3', text: '名称3' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],3, 'grid');
  public disabled(item : Common.Commodity) {
    return item == null || item.state != Common.MasterBaseStatus.Posted;
  }


  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseTrade = this.$api.hasLicense(Common.licenseFlags.import) || this.$api.hasLicense(Common.licenseFlags.export);

    // 利用する機能によって表示項目を制御する
    this.$set(this.tabVisibles, 2, this.$api.useOperationFunction);
    this.$set(this.tabVisibles, 3, this.$api.useStockFunction);
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction);
    this.$set(this.tabVisibles, 5, this.$api.useStockFunction);
    this.$set(this.tabVisibles, 7, this.$api.useStockFunction);

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('コード', 150),
      new Common.GridItemConfiguration('名称', 200),
       new Common.GridItemConfiguration('計上単位', 150),
      new Common.GridItemConfiguration('棚卸商品区分', 150),
      new Common.GridItemConfiguration('型番', 150),
      new Common.GridItemConfiguration('メーカー', 150),
      new Common.GridItemConfiguration('名称2', 200,this.hasLicenseTrade),
      new Common.GridItemConfiguration('名称3', 200,this.hasLicenseTrade),  
      new Common.GridItemConfiguration('Net(kg)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('Gross(kg)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('Volume(m3)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('category_11', 150),
      new Common.GridItemConfiguration('category_12', 150),
      new Common.GridItemConfiguration('category_13', 150),
      new Common.GridItemConfiguration('category_14', 150),
      new Common.GridItemConfiguration('category_15', 150),
      new Common.GridItemConfiguration('category_16', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者 ', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.importQuery.hasLicenseTrade = this.hasLicenseTrade;
    this.exportQuery.hasLicenseTrade = this.hasLicenseTrade;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    this.$api.formatter.ensureListLoaded('workflow_masterBase');        
  }

  public async onCreate(obj: Common.Commodity) {
    if(this.params != null && this.params.isNoStock != null) obj.isNoStock = this.params.isNoStock;
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Commodity):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.Commodity):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  public showPriceCheckDialog(item: Common.Commodity) {
    this.priceCheckPriceType = Common.PriceTypes.SalesPlice;
    this.priceCheckCounterpart = null;
    this.priceCheckSku = null;
    this.priceCheckQuantity = 1;
    this.priceCheckUom = item.replenishmentUom2;
    this.priceCheckBaseDate = new Date().getCalendarDate();
    // (this.$refs.priceCheckDialog as Components.ListDialog).showDialog();
    this.priceCheckDialog = true;
  }

  public submitPriceCheck(event:any) {
    if (!this.priceCheckEditor.validator.validate()) {
      event.preventDefault();
      return;
    }

    var query = new Common.CommodityPriceCheckQuery();
    query.commodity = (this.$refs.mainList as Components.ListView).selected;
    query.priceType = this.priceCheckPriceType;
    query.counterpart = this.priceCheckCounterpart;
    query.sku = this.priceCheckSku;
    query.quantity = this.priceCheckQuantity;
    query.uom = this.priceCheckUom.code;
    query.baseDate = this.priceCheckBaseDate;
    this.$api.execute(query).then(res => {
      this.$api.modal.show('単価取得結果', res, true, null);
      return true;
    }).catch(()=>{return false;});
    event.preventDefault(); // 確認子画面は閉じない
  }

  // 上代単価を0許容に
  // public sellingPriceRequired(item: Common.Commodity):boolean {
  //   return item.priceType == Common.SalesPricingTypes.PricingRate;
  // }

  // 一覧選択時に明細表示ボタンを非活化状態更新

  disableShowConversion :boolean = false;
  disableShowSku :boolean = false;  
  disableShowPrice :boolean = false;    
  disableShowShelfNo:boolean = false;
  public onSelectedMain(index: number, selected: Common.Commodity) {

      this.disableShowConversion = selected.state != Common.MasterBaseStatus.Posted;
      this.disableShowSku = selected.state != Common.MasterBaseStatus.Posted;
      this.disableShowPrice = selected.state != Common.MasterBaseStatus.Posted;            
      this.disableShowShelfNo = selected.state != Common.MasterBaseStatus.Posted;
    
    // 補充単位はコードしか持たないため、クライアント側で選択時に取得
    if(selected.replenishmentUomCode != null && selected.replenishmentUomCode != selected.uom) {
      var query = new Common.ConversionQuery();
      query.commodityCode = selected.code;
      query.code = selected.replenishmentUomCode;
      this.$api.execute(query).then(res => {
        var items = (res as Common.LoadResult).result;
        if(items!=null)selected.replenishmentUom = items[0];
        else selected.replenishmentUom = selected.getDefaultConversion();
      });
    }
    else{
      selected.replenishmentUom = selected.getDefaultConversion();
    }

    //変更履歴のロードなどあると若干タイムラグが発生する
    // var query = new Common.CommodityChildItemQuery(selected);
    // this.$api.execute(query).then(res => {
    //   var result = res as Common.CommodityChildItemResult;
    //   this.disableShowConversion = result.hasConversionItems == false;
    //   this.disableShowSku = result.hasSkuItems == false;
    //   this.disableShowPrice = result.hasPriceItems == false;            
    //   this.disableShowShelfNo = result.hasShelfNoItems == false;
    // });
  }

  //明細表示ボタンクリック時に画面遷移
  public showChildItems(item: Common.Commodity, flag:string)
  {
      if (flag == 'conversion')
        this.$router.push(String.format('/master/Conversion?commodityCode={0}', item.code));      
      else if (flag == 'sku')
        this.$router.push(String.format('/master/SKU?commodityCode={0}', item.code));
      else if (flag == 'price')
        this.$router.push(String.format('/master/Price?commodityCode={0}', item.code));      
      else if (flag == 'shelfNo')
        this.$router.push(String.format('/master/ShelfNo?commodityCode={0}', item.code));            
  }

  public isRequiredBarcode(barcodeType: Common.BarcodeTypes){
    return barcodeType > 0;
  }  
}

</script>
<style lang="scss">
.cx_commodity_tab
{
  >div{
    display:flex;
    flex-direction:column;
  }
}
</style>